module.exports = __webpack_public_path__ + "static/media/Book.2ec6e4d5.svg";